import React from 'react';
import styled from 'styled-components';

const Button = styled.div`
  font-size: 14px;
  color: var(--color-deep-gray);

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

interface ButtonLinkProps {
  onClick: () => void;
  children: React.ReactNode;
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ onClick, children }) => {
  return <Button onClick={onClick}>{children}</Button>;
};

export default ButtonLink;
